import React from "react";
import styles from "./HowItWorks.module.css";

const steps = [
    {
        id: 1,
        number: "01",
        title: "Request a Service",
        description: "Browse and select the concierge service you need.",
    },
    {
        id: 2,
        number: "02",
        title: "Concierge Assigned",
        description: "A verified professional is matched to your request.",
    },
    {
        id: 3,
        number: "03",
        title: "Service Fulfilled",
        description: "Your concierge handles every detail with care.",
    },
    {
        id: 4,
        number: "04",
        title: "Task Delivered",
        description: "Receive updates and confirmation of completion.",
    },
];

function HowItWorks() {
    return (
        <section className={styles.section}>

            <div className={styles.heading}>
                <h2>How It Works</h2>
                <p>Getting started is simple. Four easy steps to concierge bliss.</p>
            </div>

            <div className={styles.grid}>
                {steps.map((step) => (
                    <div key={step.id} className={styles.step}>
                        <span className={styles.number}>{step.number}</span>
                        <h3>{step.title}</h3>
                        <p>{step.description}</p>
                    </div>
                ))}
            </div>

        </section>
    );
}

export default HowItWorks;